import { ENVIRONMENT_VARIABLES_API } from '~utils/constants'

// const BASE_URL = 'http://localhost:8080'
const BASE_URL = window.location.origin

export const getEnv = async () => {
  return await fetch(`${BASE_URL}${ENVIRONMENT_VARIABLES_API}`)
}
